module.exports = __webpack_public_path__ + "static/media/office_3.23109e3f.jpg";